<script setup lang="ts">
import { RouterView } from 'vue-router'
import SidebarMain from '@/components/sidebar/SidebarMain.vue'
import NavbarMain from '@/components/navbar/NavbarMain.vue'
</script>

<template>
  <div class="flex gap-4 w-full">
    <sidebar-main></sidebar-main>

    <div class="w-full overflow-x-hidden pr-4">
      <navbar-main></navbar-main>
      <RouterView />
    </div>
  </div>
</template>

<style scoped></style>
